import type { Informacion } from '../api';

export default function WhatsAppFab({ info }: { info: Informacion | null }) {
  if (!info?.whatsapp) return null;

  return (
    <a
      href={`https://wa.me/${info.whatsapp}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 w-[60px] h-[60px] rounded-full bg-gold flex items-center justify-center text-2xl shadow-2xl animate-pulse-wsp"
      aria-label="Escribinos por WhatsApp"
    >
      💬
    </a>
  );
}
